import $ from 'jquery';
window.$ = window.jQuery = $;
window.Popper = require('popper.js').default;
require('bootstrap');
import 'slick-carousel';

import Global from './classes/Global.js';
import Home from './classes/Home.js';
import Partner from './classes/Partner.js';
import Service from './classes/ValidationService.js';
import Search from './classes/Search.js';
import Careers from './classes/Careers.js';
import GoogleMaps from './classes/GoogleMaps.js';
import CaseStudy from './classes/CaseStudy.js';



// WEBPACK FOOTER //
// ./wp-content/themes/variscale/library/js/imports.js